module.exports = __webpack_public_path__ + "img/gb9877_1-88-18x35x7.prt.b1f0c1cf.jpg";